// extracted by mini-css-extract-plugin
export default {"root":"ProductSizeChart_root__laZEP","spinAround":"ProductSizeChart_spinAround__D3YkV"};